import axios from "axios";
import axiosInstance from "../axiosInstance";
import { V1_API_ORIGIN } from "../../config/constants.config";

export const myServiceService = () => {
  if (typeof window !== 'undefined') {
    const uid = localStorage.getItem("uid");
    return axiosInstance.get(`${V1_API_ORIGIN}/users/services?userId=${uid}`);
  }
}

export const checkPaymentService = (pid) => {
  return axiosInstance.get(`${V1_API_ORIGIN}/payments/${pid}`);
}

export const activeServices = (pid) => {
  return axiosInstance.get(`${V1_API_ORIGIN}/payments/active-services/${pid}`);
}
